import type { PayloadAction, SliceCaseReducers } from "@reduxjs/toolkit";
import type {
  SpecsEditorIconPickerTarget,
  SpecsEditorSession,
} from "../../../../containers/SpecsEditor/types";

export const aiReducers = {
  openIconPicker(
    state,
    { payload }: PayloadAction<Exclude<SpecsEditorIconPickerTarget, null>>
  ) {
    state.iconPickerTarget = payload;
  },

  closeIconPicker(state) {
    state.iconPickerTarget = null;
  },

  updateFalSettings(
    state,
    { payload }: PayloadAction<Partial<SpecsEditorSession["falSettings"]>>
  ) {
    Object.assign(state.falSettings, payload);
  },
} satisfies SliceCaseReducers<SpecsEditorSession>;
